document.addEventListener('DOMContentLoaded', () => {
  const practiceDescription = document.querySelector('.practice .a-long-text.is-md.js-markdown-view');
  const pageNav = document.querySelector('.page-nav');

  if (practiceDescription && pageNav) {
    const headings = {
      h2: Array.from(practiceDescription.querySelectorAll('h2')),
      h3: Array.from(practiceDescription.querySelectorAll('h3'))
    };

    pageNav.querySelectorAll('.page-nav__item-link.page-nav__item-link__internalLink').forEach((link) => {
      const dataType = link.getAttribute('data-type'); // h2 or h3
      if (!dataType || !headings[dataType]) return;

      let matchedElement = null;

      headings[dataType].forEach((heading) => {
        if (!heading.dataset.used && !matchedElement && heading.textContent.trim() === link.textContent.trim()) {
          matchedElement = heading;
          heading.dataset.used = "true"; // 設定されたかどうかのフラグ設定
        }
      });

      if (matchedElement) {
        link.addEventListener('click', (e) => {
          e.preventDefault()
          const headerHeight = document.querySelector('.header').offsetHeight
          const position = matchedElement.offsetTop - headerHeight
          window.scrollTo({
            top: position,
            behavior: 'smooth'
          })
        })
      }
    });
  }
});
